<template>
    <div class="d-flex flex-column h-100 mobile">
        <div class="navbar-container ">
            <img id='bgIMG' alt="Image" src="../assets/background/bg3.jpg" class="bg-image opacity-30 jarallax-img" style="max-width:210px"/>
            <div class="bg-dark navbar-dark">
                <div class="container nav_con" style="max-width: 100%;padding: 0 20px;">
                    <nav class="navbar navbar-expand-lg ">
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" 
                            aria-expanded="false" aria-label="Toggle navigation" @click.prevent="show">
                            <i class="icon-menu h4"></i>
                        </button>
                        <!-- justify-content-between-->
                        <div class="collapse navbar-collapse " id="navbarNav">
                            <img src="../assets/dms_logo.png" alt="dmslogo" id='dmslogo' height="100" width="120">
                        <ul class="navbar-nav mb-auto">
                            <li class="nav-item">
                                <router-link to="/searcher" class="nav-link" :class="routeName == 'searcher' ? 'active' : ''">Search</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/myfiles" class="nav-link" :class="routeName == 'myfiles' ? 'active' : ''">My Files</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/upload" class="nav-link" :class="routeName == 'upload' ? 'active' : ''">Upload</router-link>
                            </li>
                            

                            <li class="nav-item">
                                <button class="btn btn-toggle nav-link" type="button" data-toggle="collapse" data-target="#navbar_bar" aria-controls="navbar_bar" 
                                    aria-expanded="false" :class="routeName == 'department' ? 'active' : ''" >
                                    Department
                                </button>
                                <div class="collapse" id="navbar_bar">
                                    <ul class="nav-bar">
                                        <li class="nav-item ml-2" v-for="(department,index) in departments" :key="index">

                                            <router-link :to="'/department?department='+department.code" >{{department.name}}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                         
                        </ul>
                        
                        <hr>
        
                            <div class="btn-group dropup">
                                <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Settings
                                </button>
                                <div class="dropdown-menu">
                                    <ul class="navbar-nav mb-2">
                                        <li class="nav-item text-center mb-2">
                                            <a @click="logout" class="cp">Logout</a>
                                        </li>
                                         <!-- <li class="nav-item text-center mb-2">
                                            <a class="cp">Change Password</a>
                                        </li> -->
                                        <li class="nav-item text-center mb-2" v-if="access == 'S'">
                                            <router-link to="/management/users" class="black" :class="routeName == 'management_users' ? 'active' : ''" >User Management</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
              

                        </div>
                        <!--end nav collapse-->
                    </nav>
                </div>
                <!--end of container-->
            </div>
        </div>
        <!--style="background-color: #00000008" -->
        <div class="main-container  scroll flex-1" >
            <router-view name="main"/>
        </div> 
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(),
            APP_NAME: process.env.VUE_APP_APPNAME,
            access: '',
            departments: {},
            dept_selected : ''
        }
    },
    computed : {
            routeName(){
                return this.$route.name
            }

    },
    methods: {
        async logout() {
            await this.$axios.get('/logout').
                    then(() => {
                        window.location.reload(true);
                    })
                    .catch(err => {
                        console.error(err);
                    })
            // this.$cookie.removeCookie(process.env.VUE_APP_COOKIEXID);
            // this.$cookie.removeCookie(process.env.VUE_APP_COOKIEAUTH);

            // var domain = 'ardentnetworks.com.ph';
            // var path = path || "/";
            // var d = new Date();
            // var date = d.setDate(d.getDate() - 1);
            // var name = 'ardentdms_xid'
            // document.cookie = name + "=; expires=" + +date + "; domain=" + domain + "; path=" + path;

            // name = 'ardentdms_token'
            // document.cookie = name + "=; expires=" + +date + "; domain=" + domain + "; path=" + path;

            // window.location.reload(true);
        },
        check_dept(dept_name){

            this.dept_selected = dept_name

        },
                
        async loadDepartments() {
            await this.$axios.get('/navdepartments')
                    .then(res => {
                        this.departments = res.data;
                        // console.log(this.departments)
                    })
                    .catch(err => {
                        console.error(err);
                        this.departments = [];
                    })

        },

        async loadAccess() {
            await this.$axios.get('/access')
                  .then(res => {
                    this.access = res.data;
                    console.log(this.access);
                  })
                  .catch(error => {
                    this.$jlalert.show(error, true);
                  })

                //   var currentUrl = window.location.pathname;
                //   console.log(currentUrl)

                //get url query ?department=EXE
                //   console.log(this.$route.query.department) // Out put EXE

        },

        show(){
            // var element = document.getElementById("home-collapse")
            var img = document.getElementById("bgIMG")
            // if(element.classList.contains("show")){
            //     element.classList.remove("show")
            // }else{
            //     element.classList.add("show")
            // }

            if(img.classList.contains("expand")){
                 img.classList.remove("expand")
            }else{
                img.classList.add("expand")
            }
        }
    },
    mounted() {
        this.loadAccess();
        this.loadDepartments();
  
    },
    created() {
        
    },
    watch: {
        routeName(data){
            if(data != 'department'){
                this.dept_selected = ''
            }
        }
    }
}
</script>

<style scoped>
.main {
    height: 100vh;
    height: -webkit-fill-available;
    max-height: 100vh;
    overflow-x: auto;
    overflow-y: hidden;
    background-color: black !important;
}
.main-container{
    background: linear-gradient(244deg, #000000, #575b5c, #7a7d7d);
    background-size: 600% 600%;

    -webkit-animation: gradient 30s ease infinite;
    -moz-animation: gradient 30s ease infinite;
    animation: gradient 30s ease infinite;
}

@-webkit-keyframes gradient {
    0%{background-position:0% 82%}
    50%{background-position:100% 19%}
    100%{background-position:0% 82%}
}
@-moz-keyframes gradient {
    0%{background-position:0% 82%}
    50%{background-position:100% 19%}
    100%{background-position:0% 82%}
}
@keyframes gradient {
    0%{background-position:0% 82%}
    50%{background-position:100% 19%}
    100%{background-position:0% 82%}
}

#bgIMG{
         filter: blur(8px);
        -webkit-filter: blur(8px);
}
ul {
    width: 100%;
}
.black{
    color: black !important;
}
.show{
    display: block !important;
}
.mobile {
    flex-direction: row !important;
}
.navbar-dark, .nav_con {
    width: 210px;
    height: 100%;
}
.navbar-nav, .navbar-collapse {
    flex-direction: column !important;
}
nav{
    height: 100%;
    align-items: unset;
}
.mb-auto {
   margin-bottom: auto !important; 
}
.navbar{
    align-items: unset !important;
    justify-content: unset !important;
}

.dept {
    cursor: pointer;
}
#navbar_bar{
    height: 350px;
    overflow: auto;
}
/* width */
#navbar_bar::-webkit-scrollbar {
  width: 5px;


}
/* Track */
#navbar_bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey !important; 
  border-radius: 10px !important;
}
 
/* Handle */
#navbar_bar::-webkit-scrollbar-thumb {
  background: lightgrey !important; 
  border-radius: 10px !important;

}

/* Handle on hover */
#navbar_bar::-webkit-scrollbar-thumb:hover {
  background: grey !important; 
}

#navbar_bar ul li:hover {
    cursor: pointer;
}

#navbar_bar ul li {
    padding-top: 5px;
    border-top:  1px solid rgba(0, 0,0,0.05);
    border-bottom:  1px solid rgba(225,225,225,0.1);
}
#navbar_bar ul {
    list-style: square;
}
/* .active {
    background: black !important;
} */
@media screen and (max-width: 991px) {
    #dmslogo{
        display: none;
    }
    #navbarNav h2 {
        display: none !important;
    }
    .navbar-nav{
        margin-top: 10px;
    }
    .btn-group{
        margin-top: auto !important;
    }
    .navbar-container img {
        /* display: none !important; */
        max-width: unset !important;
        width: 100%;
        height: 57px;
        max-height:350px !important;
    }
    .expand{
           height: 100% !important;
    }
    .mobile {
        flex-direction: column !important;
    }
    .navbar-dark, .container {
        width: 100% !important;
        /* height: 100%; */
    }
    /* .navbar-nav, .navbar-collapse {
        flex-direction:  !important;
    } */
    .navbar-collapse{
        justify-content: space-between;
    }
    nav{
        height: unset !important;
        /* justify-content: start !important; */
        align-items: center !important;
    }
    .mb-auto {
        margin-bottom: 0 !important; 
    }
    
}
/* @media screen and (max-width: 972px) {
    
} */
</style>